import React, { FC } from 'react';
import { LeftCircleTwoTone } from '@ant-design/icons';
import styles from './Annotation.module.scss';
import classNames from 'classnames';

type ArrowIconLeftProps = {
  right: string;
  top: string;
  fullscreen: boolean;
  OnChangeTreeAndViewImage: Function;
  treeOrViewImage: boolean;
  isImageLoaded: boolean;
  treeIcon?: boolean;
  isVisible: boolean;
  onHover?: () => void;
  onLeave?: () => void;
  hideIconTree?: boolean;
};

export const ArrowIconLeft: FC<ArrowIconLeftProps> = ({
  right,
  top,
  fullscreen,
  OnChangeTreeAndViewImage,
  treeOrViewImage,
  isImageLoaded,
  treeIcon,
  isVisible,
  onHover,
  onLeave,
  hideIconTree
}) => {
  return (
    <div
      style={{ display: isImageLoaded ? '' : 'none', zIndex: 99999, padding: '10px' }}
      onMouseEnter={() => onHover && onHover()}
      onMouseLeave={() => onLeave && onLeave()}
      className={classNames(styles.hideIcon, { [styles.shown]: isVisible })}
    >
      <LeftCircleTwoTone
        className={classNames({ [styles.iconTreeResponsive]: treeIcon })}
        onClick={() => isImageLoaded && OnChangeTreeAndViewImage(!treeOrViewImage)}
        style={{
          fontSize: '30px',
          position: 'absolute',
          right,
          top: top,
          zIndex: 99999,
          display: fullscreen || hideIconTree ? 'none' : ''
        }}
      />
    </div>
  );
};
